import { CheckboxProps, Checkbox as MuiCheckbox, SxProps, Theme } from '@mui/material';

import {
  RoundCheckboxBlankIcon,
  RoundCheckboxIcon,
  RoundIndeterminateCheckboxIcon,
} from '../../icons';

const customStyles: Record<string, SxProps<Theme>> = {
  '&.MuiCheckbox-root': {
    marginLeft: '0px',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '16px',
  },
};

export function Checkbox(props: CheckboxProps) {
  return (
    <>
      <MuiCheckbox
        size={props.size ?? 'small'}
        sx={{ ...customStyles, ...props.sx } as SxProps<Theme>}
        icon={<RoundCheckboxBlankIcon />}
        indeterminateIcon={<RoundIndeterminateCheckboxIcon />}
        checkedIcon={<RoundCheckboxIcon />}
        {...props}
      />
    </>
  );
}
